import { render, staticRenderFns } from "./AllSearch.vue?vue&type=template&id=71e1e3e6&"
import script from "./AllSearch.vue?vue&type=script&lang=js&"
export * from "./AllSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports